import { useSelector } from 'react-redux'

import {
  GetIsEAPSessionCountExhaustedOptions,
  useFlags,
  useGetIsEAPSessionCountExhaustedShared,
} from '@lyrahealth-inc/shared-app-logic'

import {
  getIsEAPSessionCountExhaustedByProgramGetter,
  getIsUserEAPSessionCountExhausted,
} from '../../data/user/userSelectors'

export function useGetIsEAPSessionCountExhausted() {
  const { forceAdultFlowsToHPI: forceAdultFlowsToHPIForAmazonExceptCFP } = useFlags()
  const isUserEAPSessionCountExhausted = useSelector(getIsUserEAPSessionCountExhausted)
  const isUserEAPSessionCountExhaustedWithoutOverrides = useSelector((state) =>
    getIsUserEAPSessionCountExhausted(state, true),
  )
  const getIsEAPSessionCountExhaustedByProgram = useSelector(getIsEAPSessionCountExhaustedByProgramGetter)

  return useGetIsEAPSessionCountExhaustedShared(
    isUserEAPSessionCountExhausted,
    isUserEAPSessionCountExhaustedWithoutOverrides,
    getIsEAPSessionCountExhaustedByProgram,
    forceAdultFlowsToHPIForAmazonExceptCFP,
  )
}

export function useIsEAPSessionCountExhausted(options: GetIsEAPSessionCountExhaustedOptions) {
  const getIsEAPSessionCountExhaustedByProgram = useGetIsEAPSessionCountExhausted()
  return getIsEAPSessionCountExhaustedByProgram(options)
}
